__turbopack_context__.v({
  "button": "AILU6G_button",
});
